const filterImageUrls = (imageUrls: (string | null)[] | null) => {
  if (imageUrls?.filter(Boolean).length === 0) {
    return null;
  }

  return imageUrls;
};

export default filterImageUrls;
